import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Creators from "@/pages/Creators";
import HowItWorks from "@/pages/HowItWorks";
import Cashouts from "@/pages/Cashouts";
import PrivacyTrust from "@/pages/PrivacyTrust";
import Ambassadors from "@/pages/Ambassadors";
import FAQPage from "@/pages/FAQ";
import Apply from "@/pages/Apply";
import Login from "@/pages/Login";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/creators" element={<Creators />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/cashouts" element={<Cashouts />} />
            <Route path="/privacy-trust" element={<PrivacyTrust />} />
            <Route path="/ambassadors" element={<Ambassadors />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/login" element={<Login />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
